import React from 'react'
import styled from 'styled-components'

const HeaderButton = (props) => (
  <StyledButton id={props.id} type="button" onClick={props.onClick} onKeyDown={props.onKeyDown}>{props.label}</StyledButton>
)

export default HeaderButton

const StyledButton = styled.button`
  color: #13294b;
  font-family: 'Open Sans', sans-serif;
  padding: 0 20px 0 20px;
  box-sizing: border-box;
  background-color: #eff0f4;
  font-size: 16px;
  font-weight: 600;
  border: 1px solid #eff0f4;
  height: 48px;
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  
  :focus {
	   border: 3px solid #FF9900;
	}
	
  @media (max-width: 768px) {
    width: 110px;
  }
  
  @media (max-width: 420px) {
    font-size: 14px;
    padding: 0 10px 0 10px;
    height: 36px;
    margin-left: 8px;
  }
`
